import React, { Component } from 'react';

class IconSidebarItemSession extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="27"
                fill="none"
                viewBox="0 0 26 27"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    stroke={this.props.isActive ? "#26A" : "#424242"}
                    d="M12.511 5.053V5.052zm-.415.542l.474-.046.437.004c3.434.03 6.484 1.093 9.16 3.21h0l.003.004c.325.252.627.534.946.832l.14.132h.001c.316.294.312.691.055.957h0l-.003.004c-.257.272-.654.299-.979-.009h0c-.755-.716-1.574-1.375-2.477-1.916h-.001a13.02 13.02 0 00-4.782-1.725c-3.077-.46-5.974.079-8.674 1.591h0l-.002.001c-.994.564-1.87 1.257-2.68 2.028h0l-.003.003c-.287.277-.574.301-.842.154h0l-.005-.003c-.41-.22-.456-.72-.215-.958a16.06 16.06 0 011.8-1.548h0a13.857 13.857 0 015.873-2.5 23.268 23.268 0 011.774-.215z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M13.641 9.587c2.209.032 4.674 1.015 6.723 2.98.341.329.49.73.352 1.195a1.14 1.14 0 01-.864.825c-.363.084-.694.01-.982-.222-.405-.328-.79-.677-1.206-.983-1.046-.74-2.209-1.184-3.49-1.364a8.205 8.205 0 00-4.13.465 7.932 7.932 0 00-2.667 1.691c-.246.233-.502.413-.854.434a1.179 1.179 0 01-1.174-.687c-.203-.465-.107-.962.267-1.332a10.509 10.509 0 013.49-2.273c1.248-.486 2.55-.74 4.535-.729z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M13.012 14.058c1.622 0 3.02.57 4.194 1.68.47.445.501 1.142.096 1.607-.427.486-1.11.54-1.633.148-.374-.275-.726-.581-1.131-.782-1.313-.634-2.914-.37-3.98.613-.257.233-.524.423-.887.433-.522.011-.97-.264-1.152-.718-.181-.455-.053-.973.32-1.321a6.085 6.085 0 013.607-1.65c.17-.031.374-.01.566-.01zM13.033 18.413c.886.031 1.57.729 1.537 1.574-.031.878-.736 1.544-1.6 1.512-.876-.032-1.549-.719-1.527-1.564a1.555 1.555 0 011.59-1.522z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemSession;